import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Grid, GridCell } from 'rmwc/Grid';
import ReactRouterPropTypes from 'react-router-prop-types'
import { TabBar, Tab, TabIcon, TabIconText, TabBarScroller } from 'rmwc/Tabs'
import { Typography } from 'rmwc/Typography'
import PlacesAutocomplete from 'react-places-autocomplete'
import { geocodeByAddress, geocodeByPlaceId, getLatLng } from 'react-places-autocomplete'
import { connect } from 'react-redux'
import * as api from '../../api/api';
import { Card } from 'rmwc/Card';
import MyResourcesTab from './MyResourcesTab'
import MyNotesTab from './MyNotesTab'

class MyCustomSection extends Component {
	constructor(props) {
    	super(props)
    	this.state = {
    		activeTabIndex: 0,
	      	selectedTabIndex: 0,
		}
	}

	componentDidMount() {
	}

	onTabChange = evt => {
	    this.setState({'activeTabIndex': evt.target.value, 'selectedTabIndex': evt.target.value})
  	};

	render() {
		return (
			<div className="mdc-layout-grid">
				<GridCell span="12">
	                <Card style={{padding: '25px'}}>
	                    <Typography use="headline6">My Custom Learning Resources</Typography>
	                </Card>
	            </GridCell>
	            <br />
		        <div className="mdc-layout-grid__inner"> 
		          	<div className="mdc-layout-grid__cell--span-12">
		              	<TabBarScroller>
		                	<div>
		                  		<TabBar
				                    activeTabIndex={this.state.activeTabIndex}
				                    onChange={this.onTabChange}>
				                    <Tab>My Resources</Tab>
				                    <Tab>My Scribbling Pad</Tab>
		                  		</TabBar>
		                  		<br />
		                	</div>
		              	</TabBarScroller>
		              	{this.state.activeTabIndex == 0 && <MyResourcesTab />}
		              	{this.state.activeTabIndex == 1 && <MyNotesTab />}
		          	</div>
		        </div>
		    </div>
		)
	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MyCustomSection);


// WEBPACK FOOTER //
// ./src/views/roadmap/MyCustomSection.jsx